import { MenuItem, TextField, Tooltip, Typography } from "@mui/material";
export const CustomSelectField = (props) => {
  const {
    label,
    variant,
    inputValues = [],
    name,
    onChange,
    onBlur,
    value,
    className,
    style,
    fieldStyle,
    error,
    isViewMode,
    disabled,
    formik,
    sx,
    accept,
  } = props;
  return (
    <>
      <TextField
        id="outlined-select-currency"
        select
        label={label}
        style={style}
        size="small"
        value={value}
        onChange={onChange}
        name={name}
        disabled={disabled || isViewMode}
        InputProps={{ readOnly: isViewMode }}
      >
        {inputValues?.map((option, index) => {
          const text = option.name || option.label || option?.[accept] || "No data Found";
          return (
            <MenuItem
              key={index}
              value={
                option?.accessor
                  ? option[option?.accessor]
                  : option.id || option.value || option?.[accept]
              }
              sx={{ maxWidth: 330 }}
            >
              <Tooltip title={text} arrow placement="right">
                <Typography noWrap sx={{ width: "100%" }}>
                  {text}
                </Typography>
              </Tooltip>
            </MenuItem>
          );
        })}
      </TextField>
    </>
  );
};
